import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  private _emitters: {
    [eventName: string]: EventEmitter<any>;
  } = {};

  public get<T>(eventName: string): EventEmitter<T> {
    if (!this._emitters[eventName]) {
      this._emitters[eventName] = new EventEmitter<T>();
    }
    return this._emitters[eventName];
  }
}
